// Chunk error handler is in index.html (must run before ES module imports)

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Clear chunk-retry counter on successful load
sessionStorage.removeItem("chunk-retry");

// Remove pre-rendered blog content (generated by vite-plugin-blog-prerender)
// so React renders cleanly without duplicate content
const prerendered = document.getElementById("prerendered-blog");
if (prerendered) prerendered.remove();

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
